import {call, put, takeEvery} from "redux-saga/effects";
import {authorizedRequest} from "utils/request";
import Polling from "utils/Polling/Polling";
import {generic} from "utils/action";
import {updateTreatmentPlanTreatmentAction} from "containers/NewTreatmentPage/actions";
import {
  PLAN_ACTIVITY,
  PLAN_ACTIVITY_FAILED,
  PLAN_ACTIVITY_RESULT_URL,
  PLAN_ACTIVITY_SUCCESS,
  PLAN_ACTIVITY_URL,
} from "./constants";

export function* planActivitySaga({ planning, timeSlotId }) {
  let res = null;

  const body = {
    data: {
      activity: {
        time_slots: [planning.timeWindow],
      },
    },
    treatmentToPlan: planning.treatmentToPlan,
    treatmentDurationCorrection: planning.treatmentDurationCorrection,
    manufacturerOffice: planning.manufacturerOffice,
    withScanner: planning.withScanner
  };
  if (timeSlotId && timeSlotId !== -1) {
    body.plannedTimeSlot = {
      id: timeSlotId,
    };
  }

  try {
    res = yield call(authorizedRequest, PLAN_ACTIVITY_URL(), {
      method: "post",
      body,
    });
  } catch (e) {
    yield put(generic(PLAN_ACTIVITY_FAILED, { reason: e.response }));
    return;
  }

  const polling = new Polling(
    { data: { token: res.additional_data.token } },
    PLAN_ACTIVITY_RESULT_URL(),
  );
  try {
    const result = yield call(() => polling.start());
    yield put(generic(PLAN_ACTIVITY_SUCCESS, { result }));
    yield put(
      updateTreatmentPlanTreatmentAction({
        ...result.plannedTreatment,
        planned: true,
      }),
    );
  } catch (e) {
    yield put(generic(PLAN_ACTIVITY_FAILED, { reason: e.response}));
  }
}

// Individual exports for testing
export default function* newTreatmentResultStepSaga() {
  // See example in containers/HomePage/saga.js
  yield takeEvery(PLAN_ACTIVITY, planActivitySaga);
}
